import { createSelector, Selector } from '@ngrx/store';
import { TableDataState } from '@app/shared/table/helpers/generic-table-state';

export const createTableStateSelector = <T extends TableDataState>(
  selector: Selector<any, T>,
  index: string,
) => createSelector(selector, (state) => state.dataTables.get(index));
